// extracted by mini-css-extract-plugin
export default {"formGroup":"DisableStreamingFormGroup_formGroup__-ckA3"};